import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { DomSanitizer } from '@angular/platform-browser';
import { SvgIconLoaderService } from '@core/services/svg-icon/svg-icon-loader.service';
import { map, switchMap } from 'rxjs';

/**
 * Inline-SVG иконка проекта (замена `tui-svg` из Taiga v3).
 * В отличие от `tui-icon` (CSS-маска в один цвет) сохраняет собственные цвета SVG,
 * поэтому глобальные стили вида `.x-product svg *[fill=...]` продолжают работать.
 * Принимает имена `x-icon::*`, `x-icon-goods::*`, `x-icon-lp::*`.
 */
@Component({
  selector: 'x-svg-icon',
  templateUrl: './svg-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-svg-icon inline-flex shrink-0 size-6',
  },
})
export class SvgIconComponent {
  private readonly loader = inject(SvgIconLoaderService);
  private readonly sanitizer = inject(DomSanitizer);

  readonly $icon = input.required<string>({ alias: 'icon' });

  // Иконки — собственные ассеты приложения, поэтому SVG считается доверенным.
  protected readonly $svg = toSignal(
    toObservable(this.$icon).pipe(
      switchMap(icon => this.loader.load(icon)),
      map(svg => this.sanitizer.bypassSecurityTrustHtml(svg)),
    ),
  );
}
